export default __webpack_public_path__ + "static/media/Bug--Tracker1.23c63a7f.svg";